export {
  Configuration,
  InitConfiguration,
  buildCookieOptions,
  DefaultPrivacyLevel,
  validateAndBuildConfiguration,
} from './configuration'
export { createEndpointBuilder, EndpointBuilder } from './endpointBuilder'
export {
  isExperimentalFeatureEnabled,
  updateExperimentalFeatures,
  resetExperimentalFeatures,
  getExperimentalFeatures,
} from './experimentalFeatures'
export * from './intakeSites'



// WEBPACK FOOTER //
// ./node_modules/@datadog/browser-core/src/domain/configuration/index.ts